module.exports = "<p>\r\n  services works!\r\n</p>\r\n"